import React from "react";
import { QrReader } from "react-qr-reader";


const QrScanner = () => {
    const handleScan = (data) => {
        if (data) {
            alert("QR Scanned: " + data);
        }
    };

    const handleError = (err) => {
        console.error(err);
    };

    return (
        <div className="p-6">
            <h2 className="text-xl font-bold mb-4">Scan QR Code</h2>

            <QrReader
                delay={300}
                onError={handleError}
                onScan={handleScan}
                style={{ width: "100%" }}
            />
        </div>
    );
};

export default QrScanner;
